module.exports = __webpack_public_path__ + "static/media/29BDOS3.b4ac750d.jpg";